export class Applicant {
  public Email: string
  public Fullname: string
  public FirstName: string
  public LastName: string
  public Phone: string

  constructor () {
    this.Email = ''
    this.Fullname = ''
    this.FirstName = ''
    this.LastName = ''
    this.Phone = ''
  }

  initialize (applicantJsonResult: any) {
    this.Email = applicantJsonResult.email
    this.Fullname = applicantJsonResult.fullname
    this.FirstName = applicantJsonResult.firstName
    this.LastName = applicantJsonResult.lastName
    this.Phone = applicantJsonResult.phoneNumber || ''
    return this
  }

  toCsv (separator: string | null): string {
    if (separator == null) {
      separator = ';'
    }
    return this.Fullname + separator + this.Email
  }
}
